import { render, staticRenderFns } from "./ElderHealth.vue?vue&type=template&id=3c092242&scoped=true&"
import script from "./ElderHealth.vue?vue&type=script&lang=js&"
export * from "./ElderHealth.vue?vue&type=script&lang=js&"
import style0 from "./ElderHealth.vue?vue&type=style&index=0&id=3c092242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c092242",
  null
  
)

export default component.exports